import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePersonLastSelectedOrganizationMutationVariables =
  Types.Exact<{
    input: Types.UpdatePersonLastSelectedOrganizationInput;
  }>;

export type UpdatePersonLastSelectedOrganizationMutation = {
  __typename?: 'Mutation';
  updatePersonLastSelectedOrganization: {
    __typename?: 'UpdatePersonLastSelectedOrganizationResponse';
    message: string;
    success: boolean;
  };
};

export const UpdatePersonLastSelectedOrganizationDocument = gql`
  mutation UpdatePersonLastSelectedOrganization(
    $input: UpdatePersonLastSelectedOrganizationInput!
  ) {
    updatePersonLastSelectedOrganization(input: $input) {
      message
      success
    }
  }
`;
export type UpdatePersonLastSelectedOrganizationMutationFn =
  Apollo.MutationFunction<
    UpdatePersonLastSelectedOrganizationMutation,
    UpdatePersonLastSelectedOrganizationMutationVariables
  >;
export function useUpdatePersonLastSelectedOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePersonLastSelectedOrganizationMutation,
    UpdatePersonLastSelectedOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePersonLastSelectedOrganizationMutation,
    UpdatePersonLastSelectedOrganizationMutationVariables
  >(UpdatePersonLastSelectedOrganizationDocument, options);
}
export type UpdatePersonLastSelectedOrganizationMutationHookResult = ReturnType<
  typeof useUpdatePersonLastSelectedOrganizationMutation
>;
export type UpdatePersonLastSelectedOrganizationMutationResult =
  Apollo.MutationResult<UpdatePersonLastSelectedOrganizationMutation>;
export type UpdatePersonLastSelectedOrganizationMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePersonLastSelectedOrganizationMutation,
    UpdatePersonLastSelectedOrganizationMutationVariables
  >;
